module.exports = __webpack_public_path__ + "static/trickster-18eacaba7c08531e7166f2e771d5add2.png";